import type { AppListenerMiddleware } from "@src/store";
import { setupSetEmbeddedNodesListener } from "./setupSetEmbeddedNodesListener";

export function setupBasicModListener(middleware: AppListenerMiddleware) {
  setupSetEmbeddedNodesListener(middleware);
}
